import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Autocomplete } from '@emburse/embark-core';
import { getEmpUDFsByKeyword } from '../../api/api';
import { $t, useTranslation } from '../../hooks/useTranslation';
function EmpUDFSearch({ value, onSelect, style, className, label, helperText, disabled, multiple, multipleType, getOptionLabel, error, id, defaultValue, disableClearable, ...props }) {
    useTranslation();
    const [lastKeyword, setLastKeyword] = useState('');
    const [lastValues, setLastValues] = useState([]);
    const getMatchingUDFs = useCallback(async (keyword) => {
        // empty keyword and there is no value in field
        if (!keyword && !value?.Name) {
            return [];
        }
        if (keyword === lastKeyword) {
            return lastValues;
        }
        // there is a value in the field. Return selected option as the only option
        if (value?.Name && !keyword) {
            const results = await getEmpUDFsByKeyword(value?.Name, props.udfIndex).then((data) => data);
            setLastValues(results);
            setLastKeyword(value?.Name);
            return results;
        }
        const results = await getEmpUDFsByKeyword(keyword, props.udfIndex).then((data) => data);
        setLastValues(results);
        setLastKeyword(keyword);
        return results;
    }, [lastKeyword, lastValues, props.udfIndex, value]);
    const changeHandler = (e, UDFValue, reason) => {
        onSelect(UDFValue, reason);
    };
    const optionLabel = (option) => option.Name || '';
    return (_jsx(Autocomplete, { style: style, className: className || '', label: label || $t('Emp UDF Search'), helperText: helperText, error: error, id: id || 'EmpUDFSearch', disabled: disabled, value: value, defaultValue: defaultValue, multiple: multiple, multipleType: multipleType, getOptionLabel: getOptionLabel || optionLabel, disableClearable: disableClearable, onChange: changeHandler, customText: { noOptionsText: $t('Type to search') }, useVirtualization: true, isAsync: true, asyncFetch: getMatchingUDFs, asyncOnChangeTimeout: 500, onBlur: (event) => {
            if (props.onBlurWithValue) {
                props.onBlurWithValue(event, value);
            }
            else if (props.onBlur) {
                props.onBlur(event);
            }
        }, ...props }));
}
EmpUDFSearch.defaultProps = {
    onSelect: () => { },
    onBlurWithValue: null
};
export default EmpUDFSearch;
